// cSpell: ignore typesafe
import { action } from 'typesafe-actions';
import { ModalActionTypes, Modal } from './types';

/* istanbul ignore next */
export const modalOpen = (modal: Modal): any => action(ModalActionTypes.OPEN, modal);
/* istanbul ignore next */
export const modalClose = (): any => action(ModalActionTypes.CLOSE);
/* istanbul ignore next */
export const modalShow = (modalId: string): any => action(ModalActionTypes.SHOW, { modalId });
/* istanbul ignore next */
export const modalHide = (modalId: string): any => action(ModalActionTypes.HIDE, { modalId });
